const state = () => ({
  dlpData: {
    heading: '',
    subheading: '',
    description: '',
    keywords: [],
    lightboxes: [],
  },
  backgroundImageUrl: '',
  elements: [],
  collections: [],
  dynamicElementsByMediaType: [],
  loadingMediaTypes: {},
  ssrLightboxElements: {},
});

const getters = {
  dlpData: ({ dlpData }) => dlpData,
  backgroundImageUrl: ({ backgroundImageUrl }) => backgroundImageUrl,
  keywords: ({ dlpData }) => dlpData.keywords,
  collections: ({ collections }) => collections,
  elements: ({ elements }) => elements,
  lightboxes: ({ dlpData }) => dlpData.lightboxes,
  mediaTypes: ({ dlpData }) => dlpData.mediaTypes || [],
  heading: ({ dlpData }) => dlpData.heading,
  description: ({ dlpData }) => dlpData.description || dlpData.subheading,
  subheading: ({ dlpData }) => dlpData.subheading,
  dynamicElementsByMediaType: ({ dynamicElementsByMediaType }) => dynamicElementsByMediaType,
  loadingMediaTypes: ({ loadingMediaTypes }) => loadingMediaTypes,
  ssrLightboxElements: ({ ssrLightboxElements }) => ssrLightboxElements,
  dlpSections(state) {
    const mediaTypes = state.dlpData.mediaTypes || [];
    return mediaTypes.map((mediaType) => {
      const existing = state.dynamicElementsByMediaType.find((x) => x.mediaType === mediaType);
      return {
        mediaType,
        elements: (existing && existing.elements) || [],
        loading: state.loadingMediaTypes[mediaType] || false,
      };
    });
  },
};

const mutations = {
  setDlpData(state, data) {
    state.dlpData = data;
    state.dynamicElementsByMediaType = [];
    state.loadingMediaTypes = {};
    state.ssrLightboxElements = {};
  },
  setSsrLightboxElements(state, { lightboxId, elements, totalCount }) {
    state.ssrLightboxElements = {
      ...state.ssrLightboxElements,
      [lightboxId]: { elements, totalCount },
    };
  },
  setBackgroundImageUrl(state, url) {
    state.backgroundImageUrl = url;
  },
  setLoadingMediaType(state, { mediaType, loading }) {
    if (mediaType != null) {
      state.loadingMediaTypes = { ...state.loadingMediaTypes, [mediaType]: loading };
    }
  },
  setDynamicElementsByMediaType(state, data) {
    const idx = state.dynamicElementsByMediaType.findIndex((x) => x.mediaType === data.mediaType);
    if (idx >= 0) {
      state.dynamicElementsByMediaType.splice(idx, 1, data);
    } else {
      state.dynamicElementsByMediaType.push(data);
    }
  },
};

function normalizeKeywords(keywords) {
  if (Array.isArray(keywords)) {
    return keywords.length ? keywords.join(',') : '';
  }
  return typeof keywords === 'string' ? keywords : '';
}

const actions = {
  searchDlpElementsByMediaTypes({ commit, state }, { keywords, mediaType }) {
    const query = normalizeKeywords(keywords || state.dlpData.keywords);
    return import('@/api/search.js').then(({ searchElements }) => searchElements(mediaType, { q: query, per_page: 12 }).then((response) => {
        const elements = response.data.data;
        if (Array.isArray(elements)) {
          commit('setDynamicElementsByMediaType', { mediaType, elements });
        }
        return response;
      }));
  },
  loadDlpSection({ state, commit, dispatch }, mediaType) {
    if (state.loadingMediaTypes[mediaType]) {
      return Promise.resolve();
    }
    const existing = state.dynamicElementsByMediaType.find((x) => x.mediaType === mediaType);
    if (existing && existing.elements && existing.elements.length > 0) {
      return Promise.resolve();
    }
    const keywords = normalizeKeywords(state.dlpData.keywords);
    if (!keywords || !mediaType) {
      return Promise.resolve();
    }
    commit('setLoadingMediaType', { mediaType, loading: true });
    return dispatch('searchDlpElementsByMediaTypes', { keywords, mediaType })
      .then(() => {})
      .finally(() => {
        commit('setLoadingMediaType', { mediaType, loading: false });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
